import { SWReactIcons } from "@similarweb/icons";
import { translate } from "app/filters/i18nFilter";
import { PlainTooltip } from "@similarweb/ui-components";
import { TooltipPlaceholder } from "../styles";

type DisabledTooltipProps = {
    isGroup: boolean;
    tooltipText?: string;
};

const DisabledTooltip = ({
    isGroup,
    tooltipText = "wizard.segments.hard.limit.tooltip.text",
}: DisabledTooltipProps) => (
    <PlainTooltip
        placement="bottom"
        tooltipContent={translate(tooltipText)}
    >
        <TooltipPlaceholder isGroup={isGroup}>
            <SWReactIcons
                iconName="info"
                size="xs"
            />
        </TooltipPlaceholder>
    </PlainTooltip>
);

export default DisabledTooltip;
